import { MarketSortOption } from '@/constants/sort';
import apiClient from '../../apiClient';

// 요청 타입 정의
export type ReqGetSpecialProducts = {
  query: {
    isPickUp?: boolean;
    isDeliveryFree?: boolean;
    isDiscount?: boolean;
    minPrice?: number;
    maxPrice?: number;
    province?: string;
    city?: string;
    villageName?: string;
    sortOption?: MarketSortOption | null;
  };
  page?: number;
};

export interface NewProductContent {
  id: number;
  createdAt: string;
  platformType: string;
  villageName: string;
  categoryId: string;
  categoryName: string;
  marketProductName: string;
  approvalStatus: string;
  businessName: string;
  originPrice: number;
  price: number;
  discountRate: number;
  discountRateEndAt?: string;
  thumbnailUrl: string;
  deliveryFee: number;
  isDeliveryFree: boolean;
  tagList: string[];
  label: string;
  state: string;
  isPickUp: boolean;
  stockAvailable: number;
  salesCount: number;
  reviewRate: number;
}

export type ResGetSpecialProducts = PaginationResponse<NewProductContent>;

// API 호출 함수
const getSpecialProducts = async ({
  query,
  page,
}: ReqGetSpecialProducts): Promise<ResGetSpecialProducts> => {
  // URLSearchParams를 사용하여 쿼리 문자열 생성
  const params = new URLSearchParams();
  if (page !== undefined) {
    params.append('page', page.toString());
  }

  // query 객체의 각 속성을 개별 쿼리 파라미터로 추가
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, value.toString()); // 숫자나 불리언 값도 문자열로 변환
    }
  });

  // API 호출
  const { data } = await apiClient.get<ResGetSpecialProducts>(
    `/app/market-products/special-deal?${params.toString()}&platformType=GROUND`
  );

  return data;
};

export default getSpecialProducts;
